import { useCallback } from 'react'
import styled from '@emotion/styled'

import MaskImage from '../../assets/images/mask@2x.jpg'

type ImageProps = {
  src: string
  fallBack?: string
}

const StyleImage = styled.img`
  object-fit: cover;
`

const Image = (
  props: ImageProps &
    React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>,
) => {
  const { fallBack, ...rest } = props
  const onError = useCallback((e) => {
    e.target.src = MaskImage
  }, [])
  return <StyleImage onError={onError} {...rest} />
}

export default Image
